var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.attribute.scroll == 'on')?_c('ic-ans-carousel',{attrs:{"attribute":this.attribute}},[_vm._t("default")],2):(_vm.type === 'list')?_c('ul',{class:this.class,style:(_vm.attribute.style)},[_vm._t("default")],2):_c('div',{class:this.class,style:(_vm.attribute.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484c85ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/IcAnsLayout/IcAnsLayout.vue
// module id = 528
// module chunks = 0